export const Props = () => ({
  //Id сигнала
  id: { type: Number },
});